<template>
  <footer class="footer">
    <div class="footer-content">
      <div>
        <div class="copyright">© 2026 by the Rosenstrasse Civil Courage Foundation | All rights reserved</div>
        <div class="copyright">The Rosenstrasse Civil Courage Foundation is a 501(c)(3) nonprofit organization tax I.D. number 873711943. Donations are tax deductible</div>
      </div>
      <a
        href="https://www.zeffy.com/en-US/donation-form/donate-to-inspire-civil-courage"
        target="_blank"
      >
        <img 
          class="donate-button"
          src="@/../public/assets/donate-button.png"
          alt="Donate"
        />
      </a>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import "@/assets/_shared.scss";

.footer {
    background-color: $navy;
    width: 70%;
    padding: 20px;
    margin: 0 auto;
    border-radius: 12px;
}

.footer-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
}

.copyright {
    color: white;
}

.donate-button {
    height: 38px;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.05);
    }
}

@media only screen and (max-width: 900px) {
    .footer {
        width: 90%;
    }

    .footer-content {
        gap: 16px;
    }
    
    .donate-button {
        height: 28px;
    }

    .copyright {
        font-size: 14px;
    }
}
</style>
